<template>
    <div id="contact">
        <div>
            <header>
                <img loading="lazy" src="../assets/004.jpg" alt="banner img" />
            </header>

            <div class="container">
                <h1>contact</h1>

                <div class="block">
                    <!-- Misurata -->
                    <section>
                        <h4>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                                <path fill-rule="evenodd" d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clip-rule="evenodd" />
                            </svg>
                            Misurata
                        </h4>
                        <p>
                            Chery Showroom
                            <br>
                            Phone: <a href="tel:+218-915655252">+218-915655252</a>
                            <br>
                            Email: <a href="mailto:sales@alimtiyazgroup.com">sales@alimtiyazgroup.com</a>
                        </p>
                    </section>

                    <!-- Benghazi -->
                    <section>
                        <h4>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                                <path fill-rule="evenodd" d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clip-rule="evenodd" />
                            </svg>
                            Benghazi
                        </h4>
                        <p>
                            Chery Showroom
                            <br>
                            Phone: <a href="tel:+218-915753838">+218-915753838</a>
                            <br>
                            Email: <a href="mailto:sales@alimtiyazgroup.com">sales@alimtiyazgroup.com</a>
                        </p>
                    </section>

                    <!-- Tripoli -->
                    <section>
                        <h4>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                                <path fill-rule="evenodd" d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clip-rule="evenodd" />
                            </svg>
                            Tripoli
                        </h4>
                        <p>
                            Chery Showroom
                            <br>
                            Phone: <a href="tel:+218-915753737">+218-915753737</a>
                            <br>
                            Email: <a href="mailto:sales@alimtiyazgroup.com">sales@alimtiyazgroup.com</a>
                        </p>
                    </section>

                    <!-- social media -->
                    <section class="social-media">
                        <h4>Social media</h4>
                        <nav>
                            <a target="_blank" href="https://www.linkedin.com/in/cherylibya"><svg class="size-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free 7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc. --><path d="M196.3 512L103.4 512L103.4 212.9L196.3 212.9L196.3 512zM149.8 172.1C120.1 172.1 96 147.5 96 117.8C96 103.5 101.7 89.9 111.8 79.8C121.9 69.7 135.6 64 149.8 64C164 64 177.7 69.7 187.8 79.8C197.9 89.9 203.6 103.6 203.6 117.8C203.6 147.5 179.5 172.1 149.8 172.1zM543.9 512L451.2 512L451.2 366.4C451.2 331.7 450.5 287.2 402.9 287.2C354.6 287.2 347.2 324.9 347.2 363.9L347.2 512L254.4 512L254.4 212.9L343.5 212.9L343.5 253.7L344.8 253.7C357.2 230.2 387.5 205.4 432.7 205.4C526.7 205.4 544 267.3 544 347.7L544 512L543.9 512z"/></svg></a>
                            <a target="_blank" href="https://www.facebook.com/cherylibyaa"><svg class="size-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free 7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc. --><path d="M240 363.3L240 576L356 576L356 363.3L442.5 363.3L460.5 265.5L356 265.5L356 230.9C356 179.2 376.3 159.4 428.7 159.4C445 159.4 458.1 159.8 465.7 160.6L465.7 71.9C451.4 68 416.4 64 396.2 64C289.3 64 240 114.5 240 223.4L240 265.5L174 265.5L174 363.3L240 363.3z"/></svg></a>
                            <a target="_blank" href="https://wa.me/218915753737"><svg class="size-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free 7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc. --><path d="M476.9 161.1C435 119.1 379.2 96 319.9 96C197.5 96 97.9 195.6 97.9 318C97.9 357.1 108.1 395.3 127.5 429L96 544L213.7 513.1C246.1 530.8 282.6 540.1 319.8 540.1L319.9 540.1C442.2 540.1 544 440.5 544 318.1C544 258.8 518.8 203.1 476.9 161.1zM319.9 502.7C286.7 502.7 254.2 493.8 225.9 477L219.2 473L149.4 491.3L168 423.2L163.6 416.2C145.1 386.8 135.4 352.9 135.4 318C135.4 216.3 218.2 133.5 320 133.5C369.3 133.5 415.6 152.7 450.4 187.6C485.2 222.5 506.6 268.8 506.5 318.1C506.5 419.9 421.6 502.7 319.9 502.7zM421.1 364.5C415.6 361.7 388.3 348.3 383.2 346.5C378.1 344.6 374.4 343.7 370.7 349.3C367 354.9 356.4 367.3 353.1 371.1C349.9 374.8 346.6 375.3 341.1 372.5C308.5 356.2 287.1 343.4 265.6 306.5C259.9 296.7 271.3 297.4 281.9 276.2C283.7 272.5 282.8 269.3 281.4 266.5C280 263.7 268.9 236.4 264.3 225.3C259.8 214.5 255.2 216 251.8 215.8C248.6 215.6 244.9 215.6 241.2 215.6C237.5 215.6 231.5 217 226.4 222.5C221.3 228.1 207 241.5 207 268.8C207 296.1 226.9 322.5 229.6 326.2C232.4 329.9 268.7 385.9 324.4 410C359.6 425.2 373.4 426.5 391 423.9C401.7 422.3 423.8 410.5 428.4 397.5C433 384.5 433 373.4 431.6 371.1C430.3 368.6 426.6 367.2 421.1 364.5z"/></svg></a>
                        </nav>
                    </section>
                </div>

                <div class="block">
                    <section style="margin: 2em 0 0 0;"><h4>get in touch</h4></section>
                    
                    <div v-if="theRes.length != 0" style="width: 100%;
                            border-radius: 10px;
                            padding: 1.2em;
                            text-transform: capitalize;
                            background: var(--noble-gold2);
                            border: 2px solid var(--noble-gold);
                            color: var(--tech-black);
                            display: flex;
                            align-items: center;
                            justify-content: space-between;">
                        {{ theRes}}

                        <button style="color: var(--tech-black);" @click="theRes=''">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="form">
                        <!-- name -->
                        <div>
                            <label class="title">Name</label>
                            <input v-model="name" type="text" placeholder="Name">
                            <span class="errorTxt" v-if="errors.name.length>1">{{ errors.name }}</span>
                        </div>

                        <!-- email -->
                        <div>
                            <label class="title">Email</label>
                            <input v-model="email" type="email" placeholder="example@xyz.com">
                            <span class="errorTxt" v-if="errors.email.length>1">{{ errors.email }}</span>
                        </div>

                        <!-- subject -->
                        <div>
                            <label class="title">Subject</label>
                            <input v-model="subject" type="text" placeholder="Subject text">
                            <span class="errorTxt" v-if="errors.subject.length>1">{{ errors.subject }}</span>
                        </div>
                    </div>

                    <div class="form" style="grid-template-columns: repeat(1, 1fr);">
                        <!-- message -->
                        <div>
                            <textarea v-model="message" placeholder="Send us a message"></textarea>
                            <span class="errorTxt" v-if="errors.message.length>1">{{ errors.message }}</span>
                        </div>
                    </div>

                    
                </div>

                <div class="cta">
                    
                    <div class="g-recaptcha" 
                    data-callback="onCaptchaVerified"
                    data-expired-callback="onCaptchaExpired"
                    data-sitekey="6LezQ64nAAAAABJ_1jDbMwjTWn07462potaAZN16"></div>

                    <button class="square" @click="sendContact()">submit</button>
                </div>
                <span style="color: red;" class="errorTxt" v-if="errors.captcha.length>1">{{ errors.captcha }}</span>
            </div>
        </div>
    </div>
</template>



<script>
    /* global grecaptcha */
import api from '@/apis';

    export default {
        data() {
            return {
                captchaToken: "", // store token here
                recaptchaWidgetId: null,
                name: "",
                email: "",
                subject: "",
                message: "",
                errors: {
                    name: "",
                    email: "",
                    subject: "",
                    message: "",
                    captcha: ""
                },
                theRes: ""
            }
        },
        
        methods: {
            validateForm() {
                // Reset errors first
                this.errors.name = "";
                this.errors.email = "";
                this.errors.subject = "";
                this.errors.message = "";

                let isValid = true;

                // ---------- NAME ----------
                if (!this.name.trim()) {
                    this.errors.name = "Name is required";
                    isValid = false;
                } else if (this.name.length < 3) {
                    this.errors.name = "Name must be at least 3 characters";
                    isValid = false;
                } else if (this.name.length > 255) {
                    this.errors.name = "Name cannot exceed 255 characters";
                    isValid = false;
                }

                // ---------- EMAIL ----------
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
                if (!this.email.trim()) {
                    this.errors.email = "Email is required";
                    isValid = false;
                } else if (this.email.length < 6) {
                    this.errors.email = "Email must be at least 6 characters";
                    isValid = false;
                } else if (this.email.length > 255) {
                    this.errors.email = "Email cannot exceed 255 characters";
                    isValid = false;
                } else if (!emailRegex.test(this.email)) {
                    this.errors.email = "Invalid email format";
                    isValid = false;
                }

                // ---------- SUBJECT ----------
                if (!this.subject.trim()) {
                    this.errors.subject = "Subject is required";
                    isValid = false;
                } else if (this.subject.length < 3) {
                    this.errors.subject = "Subject must be at least 3 characters";
                    isValid = false;
                } else if (this.subject.length > 255) {
                    this.errors.subject = "Subject cannot exceed 255 characters";
                    isValid = false;
                }

                // ---------- MESSAGE ----------
                if (!this.message.trim()) {
                    this.errors.message = "Message is required";
                    isValid = false;
                } else if (this.message.length < 10) {
                    this.errors.message = "Message must be at least 10 characters";
                    isValid = false;
                } else if (this.message.length > 50000) {
                    this.errors.message = "Message cannot exceed 50000 characters";
                    isValid = false;
                }

                return isValid;
            },
            sendContact() {
                this.errors.captcha = "";

                if (!this.validateForm()) {return;}
                if (!this.captchaToken) {
                    this.errors.captcha = "Please complete the captcha.";
                    return;
                }

                
                api.post("/contact?locale=en", {
                    name: this.name,
                    email: this.email,
                    subject: this.subject,
                    message: this.message,
                    'g-recaptcha-response': this.captchaToken // <-- this is critical
                })
                .then(res => {
                    this.theRes = res.data.message;
                    // ✅ Safely reset reCAPTCHA — only if available
                    if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) {
                        // For auto-rendered reCAPTCHA with single widget, reset with no ID
                        grecaptcha.reset();
                        this.captchaToken = null;
                    }
                })
                .catch(error => {
                    // console.log(error);
                    // ✅ Safely reset reCAPTCHA — only if available
                    if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) {
                        // For auto-rendered reCAPTCHA with single widget, reset with no ID
                        grecaptcha.reset();
                        this.captchaToken = null;
                    }

                    // GLOBAL GUARD
                    if (!error.response ||
                        error.response.status !== 422 ||
                        !error.response.data ||
                        !error.response.data.errors) {
                        // not a validation error → ignore field mapping
                        return;
                    }

                    const backendErrors = error.response.data.errors;

                    // Reset errors first
                    this.errors.name = "";
                    this.errors.email = "";
                    this.errors.subject = "";
                    this.errors.message = "";

                    // map backend errors safely
                    Object.keys(this.errors).forEach(field => {
                        if (backendErrors[field]) {
                        this.errors[field] = backendErrors[field][0];
                        }
                    });
                });
            },
            
            
        },
        mounted() {
            // reCAPTCHA calls these global functions
            window.onCaptchaVerified = (token) => {
                this.captchaToken = token;
                console.log("✅ CAPTCHA verified:", token);
            };

            window.onCaptchaExpired = () => {
                this.captchaToken = null;
                // console.log("⚠️ CAPTCHA expired");
            };
        },
        beforeDestroy() {
            // Clean up to avoid memory leaks
            delete window.onCaptchaVerified;
            delete window.onCaptchaExpired;
        },
    }
</script>